import moment from 'moment'
import { DATE } from '@/constants/constants'
import { uiHelper } from '@/utils'

export default function dateTimeFormat(value) {
  let lang = uiHelper.getLocalStorage('language')
  moment.locale(lang === 'zh' ? 'zh-cn' : lang)
  let result = ''

  if (value != undefined && value != null && value != '') {
    //Date time format in ISO8601 format 'YYYY-MM-DDTHH:mm:ss.000000Z' mean date time in UTC
    //moment will auto convert it into client timezone
    return moment(String(value)).format(DATE.LONG)
  }

  return result
}
